var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import { useModalContext } from '../context';
/**
 * # Modal.Header
 *
 * 모달의 헤더 영역입니다.
 *
 * @example ```tsx
 * <Modal.Header>This is a modal</Modal.Header>
 * ```
 */
var Header = function (props) {
    var children = useModalContext(props).children;
    return (<Wrapper>
      <div>{children}</div>
    </Wrapper>);
};
var Wrapper = styled.header(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  color: ", ";\n  padding: 19px 14px;\n  text-align: center;\n  text-transform: uppercase;\n"], ["\n  background: ", ";\n  color: ", ";\n  padding: 19px 14px;\n  text-align: center;\n  text-transform: uppercase;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.PRIMARY.BACKGROUND;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.PRIMARY.FOREGROUND;
});
export { Header };
var templateObject_1;
//# sourceMappingURL=Header.jsx.map